import { ReportDashboardsFeatureDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface UseReportDashboardsFeatureResult {
  loading: boolean
  enabled: boolean
}

type UseReportDashboardsFeatureOptions = {
  skip?: boolean
}

export const useReportDashboardsFeature = ({
  skip = false,
}: UseReportDashboardsFeatureOptions = {}): UseReportDashboardsFeatureResult => {
  const { data, loading } = useQuery(ReportDashboardsFeatureDocument, { skip })

  const enabled = Boolean(
    data?.permissions?.contextlessPolicyResolutions?.find(
      (resolution) => resolution.id === 'OpenAi_useReportDashboards'
    )?.can
  )

  return { loading, enabled }
}
